import { observer } from 'mobx-react';
import React from 'react';
import { makeAutoObservable } from 'mobx';
import { IUserConfigPackage } from '../../../API';
import DocumentSearchBar, { DocumentSearchBarState } from './DocumentSearchBar';
import DocumentSearchResults, {
	DocumentSearchResultsState,
} from './DocumentSearchResults';
import { Stack, StackItem } from '@fluentui/react';
import DocumentViewerDialog, {
	DocumentViewerDialogState,
} from './DocumentViewerDialog';
import DocumentSearchScopeSelector, {
	DocumentSearchScopeSelectorState,
	DocumentSearchScopeSelectorStyle,
} from './DocumentSearchScopeSelector';
import { IDocumentSearchScope } from '../../../API';

export interface IDocumentSearchProps {
	state: DocumentSearchState;
}

class DocumentSearch extends React.Component<IDocumentSearchProps, {}> {
	render() {
		return (
			<>
				<Stack>
					<DocumentViewerDialog state={this.props.state.docViewer} />

					<DocumentSearchScopeSelector
							style={DocumentSearchScopeSelectorStyle.Tabs}
							state={this.props.state.scopeDropdown}
						/>

					<Stack horizontal>
						<StackItem grow>
							<DocumentSearchBar state={this.props.state.bar} />
						</StackItem>
					</Stack>
					
					<DocumentSearchResults state={this.props.state.results} />
				</Stack>
			</>
		);
	}
}

export class DocumentSearchState {
	
	public bar: DocumentSearchBarState;
	public results: DocumentSearchResultsState;
	public userConfig: IUserConfigPackage;
	public docViewer: DocumentViewerDialogState;
	public scopeDropdown: DocumentSearchScopeSelectorState;
	showAllDocsInitially: boolean;
	onAttachToEmail: (item: any) => void;


	constructor(userConfig: IUserConfigPackage, showAllDocsInitially:boolean, onAttachToEmail: (item:any) => void) {
		makeAutoObservable(this);
		this.userConfig = userConfig;
		this.showAllDocsInitially = showAllDocsInitially;
		this.onAttachToEmail = onAttachToEmail;

		this.docViewer = new DocumentViewerDialogState(userConfig);

		this.bar = new DocumentSearchBarState(userConfig, (searchText) => {
			//When search bar text is updated, notify the results pane
			this.results.setSearchText(searchText);
		});

		this.results = new DocumentSearchResultsState(userConfig, false, (resultItem) => {
			//Show the document viewer dialog when an item is selected
			this.docViewer.show(
				resultItem.webUrl,
				resultItem.name,
			);
		}, this.onAttachToEmail);

		this.scopeDropdown = new DocumentSearchScopeSelectorState(
			userConfig,
			(scope?:IDocumentSearchScope) => {
				if(!scope) {
					this.bar.setCaption('Search all documents...')
					this.results.showAllItems();
				} else {
					this.bar.setCaption('Search ' + scope.Title + '...')
					this.results.setSearchScope(scope.Id);
				}
			},
		);

		if(showAllDocsInitially) {
			this.scopeDropdown.addAdditionalScope({Title: 'All Documents', Scope: ''} as IDocumentSearchScope);
		}
	}

}

export default observer(DocumentSearch);
